export default {
  path: "/main/system/role",
  name: "Role",
  component: () => import("@/views/main/System/Role/role.vue"),
  children: []
};
